import template from './admin-hotel-edit-bar.html';
import {adminStates} from './../../admin-routes';

const DIRECTIVE_NAME = AdminHotelEditBar.DIRECTIVE_NAME = 'ktAdminHotelEditBar';
export default function AdminHotelEditBar() {
    return {
        restrict: 'A',
        require: [DIRECTIVE_NAME, '^form'],
        controller: AdminHotelEditBarController,
        controllerAs: 'adminHotelEditBarCtrl',
        template,
        bindToController: true,
        scope: {
            hotel: `=${DIRECTIVE_NAME}`,
        },
        link: function($scope, $elem, $attrs, [adminHotelEditBarCtrl, formCtrl]) {
            Object.assign(adminHotelEditBarCtrl, {formCtrl});
            adminHotelEditBarCtrl.$onInit();
        },
    };
}

export function AdminHotelEditBarController(
    $scope,
    $state,
    adminHotelEditService,
    adminHotelEditBarService
) {
    'ngInject';

        const vm = this;
        let originalHotel;

        Object.assign(vm, {
            $onInit,
            cancelChanges,
            saveChanges,
            isDataModified: false,
        });

        function $onInit() {
            initTogglingSaveButton();
        }

        function initTogglingSaveButton() {
            originalHotel = angular.copy(vm.hotel);

            $scope.$watch(() => vm.hotel, (hotel) => {
                vm.isDataModified = isDataModified(hotel);
                if (vm.isDataModified) {
                    adminHotelEditBarService.showMessageIfUserClosesTab();
                } else {
                    adminHotelEditBarService.dontShowMessageIfUserClosesTab();
                }
            }, true);
        }

        function cancelChanges() {
            if (!isDataModified(vm.hotel)) {
                redirectToHotelView();
                return;
            }

            adminHotelEditBarService.confirmCancellingChanges()
                .then(redirectToHotelView);

        }

        function redirectToHotelView() {
            const {id: hotelId} = vm.hotel;
            $state.go(adminStates.HOTEL_VIEW, {hotelId});
        }

        function isDataModified(hotel) {
            return adminHotelEditService.isDataModified(originalHotel, hotel);
        }

        function saveChanges() {
            if (vm.formCtrl.$invalid) {
                adminHotelEditBarService.scrollToTheFirstSectionWithError();
                return;
            }

            adminHotelEditService.saveHotelProfile(vm.hotel)
                .then(redirectToHotelView);
        }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-edit/admin-hotel-edit-bar/admin-hotel-edit-bar-component.js